var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useRef } from 'react';
import { Button, Divider } from 'day8-ui';
import { IoMdTime } from "@react-icons/all-files/io/IoMdTime";
import { IoMapOutline } from "@react-icons/all-files/io5/IoMapOutline";
import { apiHost } from '../../config';
import moment from 'moment';
var fetchItinerary = function (bookingId) { return __awaiter(void 0, void 0, Promise, function () {
    var response, errorData, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!bookingId) {
                    throw new Error('bookingId is required');
                }
                return [4 /*yield*/, fetch("".concat(apiHost, "/api/booking/").concat(bookingId, "/itinerary"), {
                        method: 'GET',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json().catch(function () { return ({}); })];
            case 2:
                errorData = _a.sent();
                throw new Error(errorData.message || "Failed to fetch itinerary: ".concat(response.status, " ").concat(response.statusText));
            case 3: return [4 /*yield*/, response.json()];
            case 4:
                data = _a.sent();
                // Handle the API response structure: { status: 'success', data: {...} }
                return [2 /*return*/, (data.data || data)];
        }
    });
}); };
var AppItinerary = function (_a) {
    var _b;
    var bookingId = _a.bookingId;
    var _c = useState(null), itineraryData = _c[0], setItineraryData = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(0), indexDay = _f[0], setIndexDay = _f[1];
    var sectionRef = useRef(null);
    useEffect(function () {
        if (!bookingId) {
            setError('Booking ID is required');
            return;
        }
        setLoading(true);
        setError(null);
        fetchItinerary(bookingId)
            .then(function (data) {
            setItineraryData(data);
            setLoading(false);
        })
            .catch(function (err) {
            console.error('Error fetching itinerary:', err);
            setError(err.message || 'Failed to load itinerary');
            setLoading(false);
        });
    }, [bookingId]);
    if (!bookingId) {
        return React.createElement("div", null, "Booking ID is required to load itinerary");
    }
    if (loading) {
        return React.createElement("div", null, "Loading itinerary...");
    }
    if (error) {
        return React.createElement("div", null,
            "Error: ",
            error);
    }
    if (!itineraryData || !itineraryData.route_days || itineraryData.route_days.length === 0) {
        return React.createElement("div", null, "No itinerary data available");
    }
    return (React.createElement("div", { ref: sectionRef },
        React.createElement("div", { className: "dui-sticky dui-top-0 md:dui-top-[80px] dui-z-10 dui-bg-white" },
            React.createElement("div", { className: "dui-flex dui-gap-4 dui-overflow-scroll dui-py-4 md:dui-py-8" }, itineraryData.route_days.map(function (day, i) { return (React.createElement(Button, { key: day.id, buttonType: indexDay != i ? 'LINK' : 'LINK_2', onClick: function () {
                    var _a;
                    setIndexDay(i);
                    (_a = sectionRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } },
                "Day ",
                day.day_number)); }))),
        React.createElement(Divider, { className: "dui-w-full dui-mb-8" }),
        React.createElement("div", { className: "" },
            React.createElement("h2", { className: "dui-text-xl" },
                "Day ",
                indexDay + 1,
                " - ",
                ((_b = itineraryData.route_days[indexDay]) === null || _b === void 0 ? void 0 : _b.title) || ''),
            React.createElement("div", { className: "dui-mt-4" }, itineraryData.route_days[indexDay].description
                .split('\n')
                .filter(function (line) { return line.trim() !== ""; })
                .map(function (line, i) { return (React.createElement("p", { key: i, className: "dui-mt-4" }, line)); })),
            itineraryData.route_days[indexDay].items.filter(function (item) { return item.is_visible; }).length > 0 && (React.createElement("div", { className: '' }, itineraryData.route_days[indexDay].items.filter(function (item) { return item.is_visible; }).map(function (item) { return (React.createElement(React.Fragment, { key: item.id },
                React.createElement(Divider, { className: "dui-w-full dui-my-8" }),
                React.createElement("div", { className: "dui-flex dui-flex-col dui-gap-2" },
                    React.createElement("h3", { className: "dui-text-xl dui-font-subheading" }, item.title),
                    (item.start_time || item.end_time) && (React.createElement("p", { className: "dui-text-sm dui-flex dui-items-center dui-gap-2 dui-text-gray-500" },
                        React.createElement(IoMdTime, null),
                        React.createElement("span", null, "".concat(moment(item.start_time).format('h:mm A')),
                            " ",
                            item.start_time && item.end_time ? ' - ' : '',
                            " ",
                            item.end_time ? moment(item.end_time).format('h:mm A') : ''))),
                    item.location && (React.createElement("p", { className: "dui-text-sm dui-flex dui-items-center dui-gap-2 dui-text-gray-500" },
                        React.createElement(IoMapOutline, null),
                        React.createElement("span", null, item.location))),
                    item.description && item.description
                        .split('\n')
                        .filter(function (line) { return line.trim() !== ""; })
                        .map(function (line, i) { return (React.createElement("p", { key: i, className: "dui-mt-4" }, line)); })))); }))))));
};
export default AppItinerary;
